import { Component } from "@angular/core";

@Component({
  selector: "lib-mySportApp.cdk",
  imports: [],
  template: ` <p>my-sport-app.cdk works!</p> `,
  styles: ``,
})
export class MySportAppCdk {}
